export default {
  options: {
    none: 'Sem código promocional para começar',
  },
  buttons: {
    next: 'Seguinte',
    back: 'Voltar',
    skip: 'Ignorar',
  },
};
